import { render, staticRenderFns } from "./bodySetting.vue?vue&type=template&id=73704b81&scoped=true&"
import script from "./bodySetting.vue?vue&type=script&lang=js&"
export * from "./bodySetting.vue?vue&type=script&lang=js&"
import style0 from "./bodySetting.vue?vue&type=style&index=0&id=73704b81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73704b81",
  null
  
)

export default component.exports